import styled from 'styled-components';

const AppLogo = styled.img`
    margin: 0 auto;
    max-height: 70px;
    max-width: 200px;
    width: 100%;
`;

export default AppLogo;
